// extracted by mini-css-extract-plugin
export default {"root":"ResultMessage_root__OZYBs","success":"ResultMessage_success__k9tVV","error":"ResultMessage_error__hKwqF"};